import { ReactNode, useEffect, useState } from "react";
import { Grid, Dialog, DialogContent, DialogTitle, IconButton, DialogProps, Box } from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";

export interface CustomDialogProps extends DialogProps {
  open: boolean;
  itemTitle: ReactNode;
  itemContent: ReactNode;
  onClose: () => void;
  colorClose: string;
  closeBgColor?: string;
  closeButtonSize?: number; // px
  closeIconSize?: number; // px
  closeOnClickBackdrop?: boolean;
}

export const CustomDialog = (dialogProps: CustomDialogProps) => {
  const [statusOpen, setStatusOpen] = useState<boolean>(dialogProps.open);

  useEffect(() => {
    setStatusOpen(dialogProps.open);
  }, [dialogProps.open]);

  return (
    <Dialog open={statusOpen} onClose={dialogProps.closeOnClickBackdrop ? dialogProps.onClose : undefined}>
      <DialogTitle>
        <Box position={"relative"} mt={2}>
          <IconButton
            sx={{
              position: "absolute",
              top: -12,
              right: -12,
              backgroundColor: dialogProps.closeBgColor || "transparent",
              width: dialogProps.closeButtonSize || 28,
              height: dialogProps.closeButtonSize || 28,
              p: 0.5,
              borderRadius: "50%",
            }}
            onClick={dialogProps.onClose}
          >
            <CloseIcon sx={{ color: dialogProps.colorClose, fontSize: dialogProps.closeIconSize || 20 }} />
          </IconButton>
        </Box>
        <Grid container direction={"column"}>
          <Grid item></Grid>
          <Grid item>{dialogProps.itemTitle}</Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>{dialogProps.itemContent}</DialogContent>
    </Dialog>
  );
};
